<script>
    import { fade, draw, fly } from "svelte/transition";
    import { expand } from "./custom-transitions.js";
    import { quintOut } from "svelte/easing";
    import { onMount } from "svelte";
  
    let running = false;
    onMount(async () => {
      running = true;
    });
  </script>
  {#if running}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 103">
        <g
        id="Layer_2"
        data-name="Layer 2"
      ><g id="Background"><g id="Window"><g id="Frame"><circle
                class="cls-1"
                cx="50.5"
                cy="50.5"
                r="49.5"
              /><path
                d="M50.5,2A48.5,48.5,0,1,1,2,50.5,48.56,48.56,0,0,1,50.5,2m0-2A50.5,50.5,0,1,0,101,50.5,50.5,50.5,0,0,0,50.5,0Z"
              /></g></g><g id="Strata"><line
              id="Lowest"
              class="cls-2"
              x1="18"
              y1="88.11"
              x2="83"
              y2="88.11"
            /><line
              id="Low"
              class="cls-2"
              x1="7"
              y1="74.11"
              x2="94"
              y2="74.11"
            /><line
              id="Mid"
              class="cls-2"
              x1="0.95"
              y1="60.11"
              x2="99"
              y2="60"
            /><line
              id="High"
              class="cls-2"
              x1="1"
              y1="42"
              x2="100"
              y2="42.11"
            /><line
              id="High-2"
              data-name="High"
              class="cls-2"
              x1="9"
              y1="24"
              x2="93"
              y2="24.11"
            /></g></g><g id="SeedLocation"><g
            id="_36_vegetable_seed"
            data-name="36_vegetable_seed"
          ><path
              class="cls-2"
              d="M42.21,85.45c-4.39-3.65-20.84-32.79-14.77-46a25.46,25.46,0,0,1,19.05-15,26.32,26.32,0,0,1,23.23,7.19c16,16.54-6,50.21-9.37,53.64S46.61,89.09,42.21,85.45Z"
            /><path
              class="cls-2"
              d="M35.56,49.75A15,15,0,0,1,39.5,39a17.43,17.43,0,0,1,12.6-5.27c7.22,0,15,5.33,15,17,0,8.63-8,20.67-12.4,24.35a5.61,5.61,0,0,1-3.47,1.56,4,4,0,0,1-.68-.07c-4.92-.94-10.42-10.69-11.6-13.08A34.45,34.45,0,0,1,35.56,49.75Z"
            /></g><line
            id="High-3"
            data-name="High"
            class="cls-2"
            x1="32.3"
            y1="31.65"
            x2="38.55"
            y2="40.06"
          /><line
            id="High-4"
            data-name="High"
            class="cls-2"
            x1="53.45"
            y1="76.36"
            x2="59.7"
            y2="84.77"
          /><line
            id="High-5"
            data-name="High"
            class="cls-2"
            x1="69.93"
            y1="32.09"
            x2="63.69"
            y2="40.49"
          /></g></g>
    </svg>
    
  {:else}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 103 203"
      src="logo.svelte"
    />
  {/if}

  
<style type="text/css">
	.cls-1,.cls-2{fill: var(--color--bg--primary);}.cls-2{stroke:#000;stroke-miterlimit:10;stroke-width:2px;}

</style>